
<template>
  <div class="mt-24 grid grid-cols-1 place-items-center">
    <p class="middle-text">{{ tips }}</p>
  </div>
</template>

<script>
import { toRefs, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { Dialog } from "vant";
import {
  getCurrentUse,
  changeBookForScan,
  getServerTime,
} from "@/service/home";
import Cookies from "js-cookie";
import qs from "qs";

export default {
  name: "scanLeaveSign",
  components: {},
  setup() {
    const user = JSON.parse(Cookies.get("user"));
    const t = parseInt(Cookies.get("t"));
    const action = Cookies.get("action");
    const router = useRouter();
    const state = reactive({
      tips: ""
    });
    onMounted(async () => {
      const serverTime  = await getServerTime();
      if (Math.abs((serverTime/29 - 509) - (t/29 - 509))>=2*60) {
        Dialog.alert({
          title: "提示",
          allowHtml: true,
          message: "二维码已失效，请刷新后再试",
        }).then(() => {
          goHome();
        });
        return false;
      }
      state.currentSeatBooking = await getCurrentUse({
        user: user.userid,
      });

      if (action == 1) {
        state.tips = "扫码签到中";
        await changeBookStatus("checkin");
      } else if (action == 2) {
        state.tips = "扫码离开中";
        await changeBookStatus("leave");
      } else if (action == 3) {
        state.tips = "扫码签离中";
        await changeBookStatus("checkout");
      }
    });
    const goHome = () => router.push("/index");
    const changeBookStatus = async (method) => {
      try {
        let currentSeatBook = state.currentSeatBooking.filter(book=>book.isSingle==1)[0];
        let bookId = currentSeatBook && currentSeatBook.id;
        if (!bookId) {
          throw new Error("您当前没有预约信息");
        }
        const result = await changeBookForScan(
          bookId,
          qs.stringify({
            id:bookId,
            _method: method,
            access_token: user.access_token,
            userid: user.userid,
            operateChannel: 3,
          })
        );
        
        if (result.status == 1) {
          Dialog.alert({
            title: "提示",
            allowHtml: true,
            message: result.msg,
          }).then(() => {
            goHome();
          });
        } else {
          throw new Error(result.msg);
        }
      } catch (error) {
        Dialog.alert({
          title: "提示",
          allowHtml: true,
          message: error.message,
        }).then(() => {
          goHome();
        });
      }
    };
    return {
      goHome,
      changeBookStatus,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" scoped>
@import "../common/style/base";
</style>